export const FEATURE_KEYS = {
    BUY_OVER_WHATSAPP: 'BOW028',
    ADVANCED_COUPON_OPTIONS: 'ADO014',
    ANALYTICS_PLUGINS: 'ANC001',
} as const